import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
const isForYou = ['Vivís en un departamento y tenés vecinos cerca que se quejan.', 'Tu perro destruye marcos de puertas, muebles o su propia cama cuando te vas.', 'Sentís una culpa paralizante cada vez que tenés que salir.', "Estás cansado de probar soluciones 'mágicas' que no duran ni 5 minutos."];
const notForYou = ['Buscás un sedante o una droga para que tu perro duerma todo el día.', 'No estás dispuesto a dedicar 10 minutos diarios a ejercicios constantes.', 'Creés que el castigo físico es la solución a un problema de miedo.'];
export function ForYou() {
  return <section className="py-12 md:py-24 bg-white" data-id="element-97">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-98">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-99">
          {/* Es para vos */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-cream-50 rounded-3xl p-6 md:p-10 border border-cream-200" data-id="element-100">
            <h3 className="text-2xl font-bold text-charcoal mb-5 md:mb-8 flex items-center gap-3" data-id="element-101">
              <span className="text-green-600 bg-green-100 p-2 rounded-full" data-id="element-102">
                <CheckCircle2Icon size={24} data-id="element-103" />
              </span>
              Este protocolo ES para vos si:
            </h3>
            <ul className="space-y-4 md:space-y-6" data-id="element-104">
              {isForYou.map((item, index) => <li key={index} className="flex gap-4 text-charcoal-light" data-id="element-105">
                  <CheckCircle2Icon className="text-green-500 shrink-0 mt-1" size={20} data-id="element-106" />
                  <span className="leading-relaxed" data-id="element-107">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* NO es para vos */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-red-50/50 rounded-3xl p-6 md:p-10 border border-red-100" data-id="element-108">
            <h3 className="text-2xl font-bold text-charcoal mb-5 md:mb-8 flex items-center gap-3" data-id="element-109">
              <span className="text-red-600 bg-red-100 p-2 rounded-full" data-id="element-110">
                <XCircleIcon size={24} data-id="element-111" />
              </span>
              Este protocolo NO es para vos si:
            </h3>
            <ul className="space-y-4 md:space-y-6" data-id="element-112">
              {notForYou.map((item, index) => <li key={index} className="flex gap-4 text-charcoal-light" data-id="element-113">
                  <XCircleIcon className="text-red-400 shrink-0 mt-1" size={20} data-id="element-114" />
                  <span className="leading-relaxed" data-id="element-115">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}